import { getVehiclesFromBrowserState } from "api/garage/getVehiclesFromBrowserState";
import { RootState } from "interfaces/generics.type";
import { Dispatch } from "redux";
import { IGetAllVehiclesAction } from "../interfaces/garage.interface";

export function getAllVehicles() {
  return (dispatch: Dispatch<IGetAllVehiclesAction, RootState>) => {
    getVehiclesFromBrowserState()
      .then((response) => {
        const { vehicles } = response;
        dispatch({
          type: "GET_ALL_VEHICLES",
          data: vehicles,
        });
      });
  };
}
